import { render, staticRenderFns } from "./AccesPlateforme.vue?vue&type=template&id=058c05d4&"
import script from "./AccesPlateforme.vue?vue&type=script&lang=ts&"
export * from "./AccesPlateforme.vue?vue&type=script&lang=ts&"
import style0 from "./AccesPlateforme.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports